module.exports = __webpack_public_path__ + "img/app-store-logo.57df8e3d.png";